import React, { useEffect } from "react";
import "./ContactUs.scss";
import { FaInstagram, FaPinterest } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="contactPage">
      <div className="contactTitle">We'd Love to Hear From You</div>
      <div className="contactDescp">
        Whether our content was of any help, or if you have any queries - we're
        here to listen
      </div>
      <div className="contactDescp">
        Feel free to reach out through email or follow us on Instagram and Pinterest
      </div>
      <div className="contact-details">
        <div className="contact-item">
          <IoMdMail size={30} />
          <a href="mailto:tldrblogs@gmail.com">tldrblogs@gmail.com</a>
        </div>
        <div className="contact-item">
          <FaInstagram size={30} />
          <a
            href="https://www.instagram.com/tldrblogs"
            target="_blank"
            rel="noopener noreferrer"
          >
            @tldrblogs
          </a>
        </div>
        <div className="contact-item">
          <FaPinterest size={30} />
          <a
            href="https://www.pinterest.com/tldrblogs/_created"
            target="_blank"
            rel="noopener noreferrer"
          >
            tldrblogs
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
